
<div class="card-link-list" *ifScreenSize="screenType.Desktop">
    <!-- Force carousel to refresh to fix issues with dots when switching to desktop from mobile -->
    <ng-container *ngTemplateOutlet="carousel"></ng-container>
</div>

<div class="card-link-list" *ifScreenSize="screenType.Mobile">
    <!-- Force carousel to refresh to fix issues with dots when switching to mobile -->
    <ng-container *ngTemplateOutlet="carousel"></ng-container>
</div>

<ng-template #carousel>
    <owl-carousel-o [options]="customOptions">
        <ng-template *ngFor="let card of linkedCardList" carouselSlide [width]="220">
            <fgbcl-card-linked-single [linkedCard]="card"></fgbcl-card-linked-single>
        </ng-template>
    </owl-carousel-o>
</ng-template>

